import _ from 'lodash'
import { useState } from 'react'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { MAIN_HEADER_HEIGHT } from '@/layouts/main'
import AgendaDrawer from './containers/AgendaDrawer'
import { AgendaScheduler, AgendaView } from './components/AgendaScheduler'

type AgendaPageProps = {
  cellDuration?: number
  defaultView?: AgendaView
  disableDrawer?: boolean
  disableSchedules?: boolean
  disableViewSwitcher?: boolean
  fullScreen?: boolean
  startDayHour?: number
  endDayHour?: number
}

export function AgendaPage(props: AgendaPageProps) {
  const {
    cellDuration,
    defaultView = AgendaView.WEEK,
    disableDrawer = false,
    disableSchedules = false,
    disableViewSwitcher = false,
    fullScreen = true,
    startDayHour = 6,
    endDayHour = 20,
  } = props

  const authUser = useAppSelector(selectAuthUser)

  const [staffs, setStaffs] = useState<string[]>(authUser ? [authUser._id] : [])

  return (
    <AgendaScheduler
      staffs={staffs}
      height={fullScreen ? window.innerHeight - MAIN_HEADER_HEIGHT : 'auto'}
      cellDuration={cellDuration}
      defaultView={defaultView}
      disableSchedules={disableSchedules}
      disableViewSwitcher={disableViewSwitcher}
      startDayHour={startDayHour}
      endDayHour={endDayHour}
      renderDrawer={
        !disableDrawer
          ? (drawerProps) => (
              <AgendaDrawer
                staffs={drawerProps.staffs}
                staffScheduleColors={drawerProps.staffScheduleColors}
                staffAppointmentVisibilities={drawerProps.staffAppointmentVisibilities}
                setStaffs={drawerProps.setStaffs}
                setStaffScheduleColors={drawerProps.setStaffScheduleColors}
                setStaffAppointmentVisibilities={drawerProps.setStaffAppointmentVisibilities}
                orderStatusFilter={drawerProps.orderStatusFilter}
                onOrderStatusFilterChange={drawerProps.onOrderStatusFilterChange}
                meetingLinkFilter={drawerProps.meetingLinkFilter}
                onMeetingLinkFilterChange={drawerProps.onMeetingLinkFilterChange}
                meetingLinks={drawerProps.meetingLinks}
              />
            )
          : undefined
      }
    />
  )
}

export default AgendaPage
